import React from "react";
import { ThreeStories } from "./ThreeStories";
import { Pick5 } from "./Pick5";
import { BackButton, NavLink } from "../NavButton";

export const Stories = ({ active, updateActiveSlide, getSlideNumber }) => {
  return (
    <div id="stories" className={`${active ? "active " : ""}item`}>
      <div
        className="fill center-on-mobile"
        style={{ backgroundImage: "url('/images/full_page/stories.jpg')" }}
      >
        <div className="container white-text">
          <div className="text-right" style={{ padding: "2% 8%" }}>
            <h1
              className="museo-sans-100"
              style={{ paddingTop: "clamp(60px, 28%, 320px)", fontSize: "clamp(3rem, 14vw, 6.75em)" }}
            >
              stories
            </h1>
            <span className="storiesDesktop">
              <h4 className="museo-sans-300">
                How you tell them makes all the difference.
              </h4>
            </span>
            <span className="storiesMobile">
              <h4 className="museo-sans-300">How you tell them</h4>
              <h4 className="museo-sans-300">makes all the difference.</h4>
            </span>
            <br />
            <NavLink onClick={() => updateActiveSlide(getSlideNumber(ThreeStories))}>
              See how we told three →
            </NavLink>
            <br />
            <br />
            <BackButton onClick={() => updateActiveSlide(getSlideNumber(Pick5))} />
          </div>
        </div>
      </div>
    </div>
  );
};
Stories.slideName = "Stories";
Stories.pathname = "/stories";
